angular.module('impactx.delegation').controller('DelegationLoginCtrl', [
    '$scope',
    'dataGen',
    'LoginService',
    '$securityManager',
    DelegationLoginCtrl]);

function DelegationLoginCtrl($scope, dataGen, LoginService, $securityManager)
{
    dataGen.getData($scope, {}, "/delegation/activedelegates");

    this.reLogin = function(user)
    {
        if (!user.isLoggedIn && !user.disabled)
        {
            var dataObj = {
                delegateUserId: user.userId
            };
            dataGen.postAsForm($scope, dataObj, "/delegation/delegatelogin").then(function ()
            {
                $securityManager.invalidateProcesses();
                LoginService.refreshUI(true);
            });
        }
    }
}